import React, { useState, useEffect } from "react";
import { useFormikContext, Field } from "formik";
import Select from "react-select";
import {
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import ContactSearchPage from "../contactSearch/ContactSearchPage";

const MarriageStep =  React.memo(({ metadata }) => {
  const { values, errors, touched, setFieldValue } = useFormikContext();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isCreatingNewConyuge, setIsCreatingNewConyuge] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [maritalOptions, setMaritalOptions] = useState([]);

  useEffect(() => {
    setMaritalOptions(
      metadata?.marital_status.map((marital) => ({
        value: marital.value,
        label: marital.spanish
      })) || []
    );
  }, [metadata, setFieldValue]);

  // Manejo de estado civil
  const handleMaritalStatusChange = (event) => {
    console.log(event)
    const maritalStatus = event?.value;
    

    if (["married", "engaged", "free_union"].includes(maritalStatus)) {
      setFieldValue("marital_status", maritalStatus);
      setFieldValue("matrimonio.conyugue.marital_status", maritalStatus);
      setShowButtons(true)
    } else {
      setShowButtons(false)
      console.log("else")
      setFieldValue("marital_status", maritalStatus);
   
      setFieldValue("matrimonio.conyugue", {
        conyugue_id: 0,
        conyugue_first_name: "",
        conyugue_middle_name: "",
        conyugue_last_name: "",
        marital_status:""
      });
      setIsCreatingNewConyuge(false); // Ocultar campos si no aplica
    }
  };

  // Selección de contacto desde el modal
  const handleSelectContact = (contact) => {
    console.log("++++++++++++++++handleSelectContact++++++++++++++++++")
    console.log(contact)
    setShowModal(false);
    setIsCreatingNewConyuge(false); // Desactivar creación de nuevo cónyuge

    setFieldValue("matrimonio.conyugue", {
      conyugue_id: contact.id,
      conyugue_first_name: contact.first_name,
      conyugue_middle_name: contact.middle_name || "",
      conyugue_last_name: contact.last_name,
    });
  };

  // Creación de un nuevo cónyuge
  const handleCreateConyuge = () => {

    setFieldValue("matrimonio.conyugue", {
      conyugue_id: 0,
      conyugue_first_name: "",
      conyugue_middle_name: "",
      conyugue_last_name: "",
    });
    setIsCreatingNewConyuge(true); // Activar modo creación de nuevo cónyuge
    setShowModal(false); // Cerrar modal
  };

  const handleOpenModal = () => {
    setLoading(true); // Mostrar Backdrop mientras carga el modal
    setTimeout(() => {
      setShowModal(true);
      setLoading(false); // Ocultar Backdrop cuando el modal esté listo
    }, 500);
  };

  return (
    <>
      <Grid container spacing={2}>
        {/* Estado civil */}

        <Grid container item xs={12} sm={6} flexDirection="column">
            {/* Etiqueta */}
            <Typography variant="subtitle1">Estado Civil</Typography>

            {/* MultiSelect de Grupos */}
            <Select
                
                options={maritalOptions}
                value={maritalOptions.find((option) => option.value === values.marital_status) || null}
                onChange={handleMaritalStatusChange}
                
                placeholder="Seleccione un estado civil"
                isClearable
                closeMenuOnSelect={true}
            />
        </Grid>

        {/* Botones para buscar o crear cónyuge */}
        {showButtons && (
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenModal}
            >
              Buscar Cónyuge
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              sx={{ marginLeft: 2 }}
              onClick={handleCreateConyuge}
            >
              Crear Cónyuge
            </Button>
          </Grid>
        )}

        {/* Campos del cónyuge */}
        {showButtons && (
          <>
            <Grid item xs={12} sm={6}>
              <Field name="matrimonio.conyugue.conyugue_first_name">
                {({ field, meta }) => (
                  <TextField
                    {...field}
                    label="Nombre del Cónyuge"
                    fullWidth
                    error={meta.touched && !!meta.error}
                    helperText={meta.touched && meta.error}
                    variant="outlined"
                    disabled={!isCreatingNewConyuge && !!values.matrimonio?.conyugue?.conyugue_id}
                  />
                )}
              </Field>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field name="matrimonio.conyugue.conyugue_middle_name">
                {({ field, meta }) => (
                  <TextField
                    {...field}
                    label="Apellido Paterno"
                    fullWidth
                    error={meta.touched && !!meta.error}
                    helperText={meta.touched && meta.error}
                    variant="outlined"
                    disabled={!isCreatingNewConyuge && !!values.matrimonio?.conyugue?.conyugue_id}
                  />
                )}
              </Field>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field name="matrimonio.conyugue.conyugue_last_name">
                {({ field, meta }) => (
                  <TextField
                    {...field}
                    label="Apellido Materno"
                    fullWidth
                    error={meta.touched && !!meta.error}
                    helperText={meta.touched && meta.error}
                    variant="outlined"
                    disabled={!isCreatingNewConyuge && !!values.matrimonio?.conyugue?.conyugue_id}
                  />
                )}
              </Field>
            </Grid>
          </>
        )}
      </Grid>

      {/* Modal para buscar cónyuge */}
      <Dialog open={showModal} onClose={(handleSelectContact) => setShowModal(false)} maxWidth="md" fullWidth>
        <DialogTitle>Buscar Cónyuge</DialogTitle>
        <DialogContent>
          <ContactSearchPage onSelectContact={handleSelectContact} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowModal(false)} color="secondary">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Backdrop para cargar modal */}
      <Backdrop
        open={loading}
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
});

export default MarriageStep;
